import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Draggable } from 'react-beautiful-dnd'
import { CloseOutlined } from '@ant-design/icons'
import { archiveMetrics } from '../../../utils/constant'
import { ReactComponent as ArchivedMetricIcon } from '../../../asserts/images/physical-assessment/FolderOpen.svg'
const Container = styled.span`
  background-color: ${props => (props.isDragging ? 'lightgray' : 'white')};
`

const ArchivedInfo = styled.div`
  display: flex;
  align-items: center;
  font-size: 16px;
  color: #888;
`

class Metric extends Component {
  static propTypes = {
    metric: PropTypes.object,
    index: PropTypes.number,
    history: PropTypes.object
  }

  render() {
    const { metric, index, deleteBiomarker, history, path } = this.props

    const isArchived =
      ((archiveMetrics.includes(metric.name) &&
        metric.name !== 'Peak Drop Landing Force Asymmetry (L/R)') ||
        (metric.name === 'Peak Drop Landing Force Asymmetry (L/R)' && metric.id === 87))

    return (
      <Draggable
        draggableId={`metric-${metric.id}`}
        index={index}
        type="metric"
      >
        {(provided, snapshot) => (
          <Container
            className="biomarker-item"
            {...provided.draggableProps}
            {...provided.dragHandleProps}
            ref={provided.innerRef}
            isDragging={snapshot.isDragging}
            onClick={() => {
              history.push(`/${path}/${metric.id}`)
            }}
          >
            <CloseOutlined
              onClick={e => {
                e.stopPropagation()
                deleteBiomarker()
              }} />
            <span>{metric.name}</span>
            {isArchived && (
              <ArchivedInfo>
                <ArchivedMetricIcon width={16} height={16} />
                <span style={{ marginLeft: '3px', marginTop: '2px', fontSize: '12px'}}>Archived</span>
              </ArchivedInfo>
            )}
          </Container>
        )}
      </Draggable>
    )
  }
}

export default Metric
